import { render, staticRenderFns } from "./addWarehouse.vue?vue&type=template&id=33d45a43&scoped=true"
import script from "./addWarehouse.vue?vue&type=script&lang=js"
export * from "./addWarehouse.vue?vue&type=script&lang=js"
import style0 from "./addWarehouse.vue?vue&type=style&index=0&id=33d45a43&prod&lang=css"
import style1 from "./addWarehouse.vue?vue&type=style&index=1&id=33d45a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d45a43",
  null
  
)

export default component.exports